import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { ENDPOINTS }                 from "src/constants/api/api";
import type { IScreenshotRequests }  from "src/store/services/time-doctor/interfaces/requests.interface";
import type { IResponseProject,
    IResponseUsers,
    ResponseFilesData, } from "src/store/services/time-doctor/interfaces/responses.interface";
import { getAccessToken } from "src/utils/token-storage";

export const timeDoctorApi = createApi({
  reducerPath: "timeDoctorApi",
  baseQuery  : fetchBaseQuery({
    baseUrl       : process.env.REACT_APP_BASE_URL,
    credentials   : "include",
    prepareHeaders: (headers) => {
      const token = getAccessToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  endpoints: (build) => ({
    getScreenshots: build.mutation<ResponseFilesData, IScreenshotRequests>({
      query: (data: IScreenshotRequests) => {
        const query = new URLSearchParams({
          userIds: data.userIds.join(","),
          date   : data.date,
        }).toString();

        const url =
          data.userIds.length > 0
            ? `${ENDPOINTS.TIME_DOCTOR.GET_SCREENSHOTS}?${query}`
            : ENDPOINTS.TIME_DOCTOR.GET_SCREENSHOTS;

        return {
          url,
          method: "GET",
        };
      },
    }),
    getUsers: build.mutation<IResponseUsers, void>({
      query: () => ({
        url   : ENDPOINTS.TIME_DOCTOR.GET_USERS,
        method: "GET",
      }),
    }),
    getProjects: build.mutation<IResponseProject, void>({
      query: () => ({
        url   : ENDPOINTS.TIME_DOCTOR.GET_PROJECTS,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetProjectsMutation,
  useGetScreenshotsMutation,
  useGetUsersMutation, } = timeDoctorApi;
